import * as React from 'react'

const Critics = ({
  critic
}) => {
  return (<>
    {critic && critic.value != 0 && critic.label !== '' &&
    <div className="field__item">
      <div
        className="field field--name-field-critic-ratings field--type-bb-product-taxonomy-and-value field--label-hidden field__items">
        <div className="icons">
          <div className="item">
            <div className="icon-bg">{critic.value}</div>
            <div className="icon-cap">{critic.label}</div>
          </div>
        </div>
      </div>
    </div>}
  </>)
}
export default Critics
